import React from 'react';
import { css } from '@compiled/react';
import { Accordion } from '@atlassian/learning-components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { sendUIEvent } from 'src/utils/analytics';
import { getOptions } from 'src/pages/LessonPage/children/utils/getOptions';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';
import { isStandalone } from 'src/pages/LessonPage/utils/isStandalone';

interface AccordionBlockProps {
  courseId: string | undefined;
  lessonId: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: Record<string, any>;
  width: number;
}

export const AccordionBlock: React.FC<AccordionBlockProps> = ({ fields, courseId, lessonId, width }) => {
  const { user } = useAtlassianUser();

  const tabsContent = fields.tabsLabel?.map((label: string, index: number) => {
    const tabContent = fields.tabsContentCollection.items[index];

    return {
      title: label,
      children: documentToReactComponents(tabContent?.content.json, getOptions(tabContent?.content, width)),
    };
  });

  return (
    <div css={[accordionContainerStyles, spacingStyles]}>
      <Accordion
        size={fields.size}
        shouldSingleTabBeOpen={fields.shouldSingleTabBeOpen}
        tabsContent={tabsContent || []}
        onChange={(tabState: { [key: number]: string } | undefined) => {
          if (tabState) {
            const [[tabIndex, state]] = Object.entries(tabState);

            sendUIEvent(
              'lessonScreen',
              'accordion',
              'clicked',
              'lessonAccordionComponent',
              {
                name: fields.name,
                lessonSlug: lessonId,
                courseSlug: courseId,
                type: state,
                tabIndex,
                isStandaloneLesson: isStandalone(),
              },
              user?.account_id,
            );
          }
        }}
      />
    </div>
  );
};

const accordionContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});

const spacingStyles = css({
  paddingTop: '40px',
  paddingBottom: '40px',
});
